import { Instagram } from "lucide-react";
import { INSTAGRAM_URL } from "./constants";

const RESULTS = [
  {
    id: "lean-bulk-66-70",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/dig2qkcq_33.jpg",
    title: "Lean Bulk · 66 → 70 kg",
    caption:
      "Massa grassa stabile (14,0% → 14,7%), +1,15 kg di muscolo netto. Senza dati vai a caso: raccogli, aggiusti, fai sempre un passo avanti.",
    tag: "Ricomposizione",
  },
  {
    id: "powerlifter-77-75",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/4qax58si_22.png",
    title: "Powerlifter · 77 → 75 kg",
    caption:
      "Massa grassa 19,0% → 17,0%, composizione ripulita e performance alzata. Niente estremismi: rientro in categoria con due tagli liquidi.",
    tag: "Sport",
  },
  {
    id: "ricomposizione-pro",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/vsafhqxm_23.png",
    title: "Ricomposizione +700 kcal",
    caption:
      "Da 76 a 79 kg con +700 kcal/giorno. Massa grassa 17,4% → 16,8%, +1,9 kg muscolo. Più libertà a tavola, stessa condizione.",
    tag: "Ricomposizione",
  },
  {
    id: "cut-pulito",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/pzm9jr63_26.png",
    title: "Cut · 67,5 → 63,5 kg",
    caption:
      "Massa grassa 18,3% → 15,2%, -2,7 kg di grasso reale. Cut pulito, ora in normocalorica con peso stabile anche con le feste di mezzo.",
    tag: "Dimagrimento",
  },
  {
    id: "bulk-intelligente",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/9oqk6vjt_53.png",
    title: "Bulk intelligente · 81,5 → 87,3 kg",
    caption:
      "+6,5 kg di muscolo e -2 kg di grasso reale. Massa grassa dal 24,7% al 20,7%. Braccio 30,5 → 35,2 cm, spalle +12 cm.",
    tag: "Ricomposizione",
  },
  {
    id: "condizione-rivoluzionata",
    img: "https://customer-assets.emergentagent.com/job_sacco-transform/artifacts/8o6c2atc_20.png",
    title: "Condizione rivoluzionata",
    caption:
      "Massa grassa 19,2% → 17,9%, -1,5 kg di grasso e +1,4 kg di muscolo. Più volume, meno grasso: bulk fatto bene.",
    tag: "Sport",
  },
];

export const Transformations = () => {
  return (
    <section
      id="trasformazioni"
      data-testid="transformations-section"
      className="relative bg-[#F7F9F7] py-20 md:py-28 border-y border-[#E1E7E3]"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 md:mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · Risultati · Instagram
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Trasformazioni reali.
              <br />
              <span className="text-[#1F6E45]">Numeri verificati.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row gap-4 lg:justify-end">
            <p className="text-[#4A5A52] text-base leading-relaxed max-w-md">
              Casi reali documentati con grafici peso/kcal, plicometria e foto
              standardizzate. Ogni cambiamento è misurato.
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ig-cta"
              className="inline-flex items-center gap-2 self-start whitespace-nowrap px-5 py-3 rounded-full bg-[#1F6E45] text-white text-sm font-semibold hover:bg-[#144A2E]"
            >
              <Instagram size={16} /> Vedi su Instagram
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {RESULTS.map((r) => (
            <Card key={r.id} {...r} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Card = ({ id, img, title, caption, tag }) => (
  <article
    data-testid={`result-card-${id}`}
    className="group bg-white rounded-2xl border border-[#E1E7E3] overflow-hidden hover:-translate-y-1 hover:border-[#1F6E45]/40 transition-all duration-300 soft-shadow flex flex-col"
  >
    <div className="relative aspect-square overflow-hidden bg-[#E8F2EC]">
      <img
        src={img}
        alt={title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute top-3 left-3 bg-white/95 backdrop-blur rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.18em] font-bold text-[#1F6E45]">
        {tag}
      </div>
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <h3 className="font-heading font-bold text-[#0E1A14] text-base md:text-lg mb-2 tracking-tight">
        {title}
      </h3>
      <p className="text-[#4A5A52] text-sm leading-relaxed">{caption}</p>
    </div>
  </article>
);
